import React, { useState, useEffect } from 'react'
import { compose, withProps } from 'recompose'
import {
  Circle,
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs
} from 'react-google-maps'
import _ from 'lodash'
import { GOOGLE_MAP_API_URL } from '../../../../config'
import { getNearByHero } from '../../../../modules/hero'
import { useDispatch, useSelector } from 'react-redux'

const initialOptions = {
  lat: '',
  lng: '',
  radius: 1000
}

export const LocationMap = ({ heroConfigs, locationList, hero }) => {
  const dispatch = useDispatch()
  const [filterOption, setFilterOption] = useState(initialOptions)
  const nearByHero = useSelector((state) => state.hero.nearByHero)

  useEffect(() => {
    if (locationList && locationList.length > 0) {
      locationList.forEach((location) => {
        const newFilterOption = {
          lat: location.lat,
          lng: location.lng,
          radius: filterOption.radius // คง radius เดิมไว้
        }
        dispatch(getNearByHero(newFilterOption))
      })
    }
  }, [dispatch, locationList, filterOption])

  const renderRadius = (type) => {
    if (hero.configByHero) {
      return hero.radius
    } else {
      const result = _.find(heroConfigs, (item) => {
        return item.heroType === type
      })
      return !_.isUndefined(result) ? result.radius : null
    }
  }

  return (
    <GoogleMap
      defaultZoom={14}
      center={{
        lat: parseFloat(locationList[0].lat || 0),
        lng: parseFloat(locationList[0].lng || 0)
      }}>
      {locationList &&
        locationList.map((location, index) => (
          <div key={index.toString()}>
            <Marker
              title={location.address}
              position={{
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
              }}
            />
            {nearByHero.map((hero) => (
              <Marker
                title={hero.name}
                position={{
                  lat: parseFloat(hero.latitude),
                  lng: parseFloat(hero.longitude)
                }}
                icon={{
                  url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                }}
                label={{
                  text: hero.name,
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              />
            ))}
            <Circle
              options={{
                strokeColor: 'transparent',
                fillColor: 'green',
                fillOpacity: 0.1
              }}
              center={{
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
              }}
              radius={
                !_.isUndefined(hero) &&
                !_.isNull(hero) &&
                renderRadius(hero.heroType)
              }
            />
            <Circle
              options={{
                strokeColor: 'transparent',
                fillColor: 'blue',
                fillOpacity: 0.2
              }}
              center={{
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
              }}
              radius={1000}
            />
          </div>
        ))}
    </GoogleMap>
  )
}

export default compose(
  withProps({
    googleMapURL: GOOGLE_MAP_API_URL,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `50vh` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(LocationMap)
